export default "__VITE_ASSET__DtsBcMpV__"